

export const catoo = {
    nextGenEngine: '新一代**AI創意工作台**，用於即時影像和影片創作',
    heroTitle: '從文字到圖像與影片，用Catoo釋放您的創造力',
    heroSubtitle: 'AI驅動的內容製作工作空間，支援圖像與影片的生成與編輯。',
    getStartedFree: '免費開始',
    viewExamples: '查看示例',
    imageGeneration: '圖片生成',
    imageGenerationDesc: '從文字或照片生成高品質圖片。',
    videoGeneration: '影片生成',
    videoGenerationDesc: '根據提示詞或參考圖片生成AI影片。',
    imageToImage: '圖像轉圖像',
    imageToImageDesc: '使用AI驅動的編輯和增強功能轉換現有圖像。',
    textToImage: '文字轉圖像',
    textToImageDesc: '使用先進的AI從文字描述生成令人驚嘆的圖像。',
    aiWorkbench: 'AI工作台',
    aiWorkbenchDesc: '專業的AI驅動圖像生成和編輯工作空間。',
    features: '功能特色',
    featuresSubtitle: '為創意專業人士提供強大的AI工具',
    advancedAI: '先進AI模型',
    advancedAIDesc: '最先進的AI技術，提供卓越的圖像質量和創造力。',
    multipleFormats: '多種格式',
    multipleFormatsDesc: '支援各種圖像格式和解析度，滿足您的需求。',
    fastProcessing: '快速處理',
    fastProcessingDesc: '快速周轉時間，提高創意工作流程效率。',
    showcaseTitle: 'Catoo 作品展示',
    showcaseSubtitle: '探索使用我們AI驅動工具創作的驚人作品',
    showcase1Caption: 'AI生成的風景畫，細節驚人，色彩鮮豔',
    showcase2Caption: '使用先進AI技術進行的創意肖像轉換',
    whatIsTitle: '什麼是Catoo？',
    whatIsDesc: 'Catoo是一個全面的AI驅動創意平台，革命性地改變內容創作。',
    unifiedStyle: '所有內容統一視覺風格',
    batchJobs: '批量處理提高工作效率',
    teamCollaboration: '無縫團隊協作功能',
    whyChooseTitle: '為什麼選擇Catoo？',
    qualityControl: '質量控制',
    qualityControlDesc: '先進的AI確保每次都能輸出一致的高質量內容。',
    highEfficiency: '高效率',
    highEfficiencyDesc: '簡化的工作流程節省時間並提高生產力。',
    costEffective: '成本效益',
    costEffectiveDesc: '可隨創意需求擴展的實惠定價計劃。',
    howToCreateTitle: '如何使用Catoo創作',
    inputIdea: '輸入您的想法',
    inputIdeaDesc: '只需用自然語言描述您想要創作的內容。',
    generateDraft: '生成草稿',
    generateDraftDesc: '我們的AI根據您的規格創建初始草稿。',
    oneClickExport: '一鍵導出',
    oneClickExportDesc: '一鍵將您的創作導出為各種格式。',
    capabilitiesTitle: '強大功能',
    imageStudio: '圖像工作室',
    imageStudioDesc: '專業的圖像生成和編輯工具。',
    storyboard: '故事板',
    storyboardDesc: '輕鬆創建視覺敘事和故事板。',
    publish: '發布',
    publishDesc: '即時在多個平台分享您的創作。',
    collaborate: '協作',
    collaborateDesc: '與您的團隊實時協作。',
    creators: '10,000+ 創作者',
    faster: '5倍更快',
    satisfaction: '98% 滿意度',
    pricingTitle: '選擇您的計劃',
    testimonialsTitle: '用戶評價',
    echoName: 'Echo Chen',
    echoTitle: '數字藝術家',
    echoTestimonial: 'Catoo改變了我的創作工作流程。AI驅動的工具非常直觀，產生令人驚嘆的結果。',
    novaName: 'Nova Kim',
    novaTitle: '內容創作者',
    novaTestimonial: '我可以在幾分鐘內創建專業質量的內容，而不是幾小時。Catoo對內容創作者來說是一個遊戲規則改變者。',
    faqTitle: '常見問題',
    faqCommercialUse: '我可以將Catoo用於商業用途嗎？',
    faqCommercialUseAnswer: '是的，使用Catoo創建的所有內容都可以無限制地用於商業用途。',
    faqOnPremise: '您提供本地部署解決方案嗎？',
    faqOnPremiseAnswer: '是的，我們為有特定安全要求的組織提供企業本地部署解決方案。',
    faqEducationDiscount: '您提供教育折扣嗎？',
    faqEducationDiscountAnswer: '是的，我們為教育機構和學生提供特殊定價。請聯繫我們了解更多詳情。',
    faqGeminiNano: 'Catoo 如何讓 Gemini Nano 更易於使用？',
    faqGeminiNanoAnswer: 'Catoo 為 Gemini Nano 提供了簡化的介面，在後台處理複雜的模型交互，讓您可以專注於創作而無需面對技術障礙。',
    faqDifference: 'Catoo 與其他 AI 影片生成工具有什麼區別？',
    faqDifferenceAnswer: 'Catoo 將 Sora、Veo 和 Wan 等多個最先進的模型集成到一個易於使用的平台中，並針對速度和用戶體驗進行了優化。',
    footerTagline: '用AI驅動的工具釋放您的創造力',
    contactEmail: '電子郵件: support@catoo.ai',
    productSection: '產品',
    imageUpscaler: '圖像放大器',
    pricing: '定價',
    myCreations: '我的創作',
    companySection: '公司',
    about: '關於',
    careers: '職業',
    contact: '聯繫',
    resourcesSection: '資源',
    showcase: '展示',
    guides: '指南',
    community: '社區',
    privacyPolicy: '隱私政策',
    privacyPolicyPage: {
      lastUpdated: '最新更新：{date}',
      intro: '本隱私政策說明 CatooAI（以下簡稱「CatooAI」「Catoo」「我們」）在您使用我們的 App、網站、AI 創作工具、訂閱與支付服務及相關功能時，如何收集、使用、揭露、保存與保護個人資訊。',
      section1Title: '1. 適用範圍與收集來源',
      section1Content: `我們透過以下三種方式收集資訊：（1）您直接向我們提供，例如註冊帳號、登入、上傳內容、購買方案、聯絡客服或調整設定時；（2）您使用裝置、瀏覽器或服務過程中自動產生的技術資訊；（3）經您授權的第三方或合作方提供的資訊，例如 Apple、Google、應用商店或支付服務商。

本政策旨在清楚說明我們收集哪些資料、如何收集、用於哪些目的、保存多久，以及您如何申請刪除資料或在適用情況下撤回同意。`,
      section2Title: '2. 我們可能收集的資訊',
      section2Content: `我們可能收集以下類別的資訊：
- 帳號與資料資訊，例如電子郵件、顯示名稱、頭像、帳號偏好，以及 Apple 或 Google 登入關聯標識。
- 購買、訂閱與訂單資訊，例如方案資訊、付款狀態、發票、應用商店收據或付款確認憑證。我們不會從支付服務商取得您的完整銀行卡號。
- 您為使用 AI 創作功能而提交的提示詞、圖片、影片、參考檔案、編輯內容及生成結果。
- 為保障服務運作與安全所需的裝置、瀏覽器、IP 位址、應用版本、崩潰資料、效能指標與安全日誌等診斷資訊。
- 僅在您主動使用需要地圖或定位的功能並授予權限時，收集大致位置或精確位置資料。
- 僅在您主動使用相關功能時，存取相機、相簿、檔案、通知或類似權限對應的資料。`,
      section3Title: '3. 照片、人臉資料、權限與使用者內容',
      section3Content: `CatooAI 的部分功能允許您上傳肖像照、證件照、自拍照或其他可能包含人臉的圖片。我們僅在您主動使用該類功能時處理此類內容。

我們處理上傳圖片、提示詞與參考檔案，僅用於完成您要求的生成、編輯、修復或增強功能。我們不會利用這些內容識別您的身分、推斷敏感屬性，或建立廣告画像。

未經您另行明確授權，我們不會將您上傳的照片、提示詞或生成內容用於訓練模型。您也可透過裝置或瀏覽器設定管理相機、相簿、通知與定位權限。`,
      section4Title: '4. 我們如何使用資訊',
      section4Content: `我們僅在與提供和改進服務相關的範圍內使用個人資訊，包括：
- 建立並交付您要求的 AI 圖片、影片、編輯結果及其他生成內容。
- 建立與管理帳號、完成登入驗證、同步歷史記錄並提供客服支援。
- 處理購買、驗證訂閱、防範詐欺、處理退款並保存必要的財務記錄。
- 維護系統安全、識別濫用、執行平台規則，並保護使用者、創作者及服務本身。
- 排查問題、分析效能並持續改進穩定性、品質與產品體驗。
- 發送重要服務通知，例如支付結果、安全提醒或政策更新。
- 遵守適用法律、合法要求及監管義務。`,
      section5Title: '5. 共享與第三方服務',
      section5Content: `我們不會出售個人資訊。只有在提供服務或履行法律義務所必需的情況下，我們才會與受信任的第三方共享有限資料。

依您使用的功能不同，這些第三方可能包括 Apple 或 Google 等登入服務商；Apple、Stripe、PayPal 或您所在地區/平台適用的支付與計費服務商；包括火山引擎（Volcengine）在內的 AI 基礎設施與模型服務商，用於處理提示詞和上傳內容並生成您要求的結果；以及協助我們提供託管、儲存、安全、日誌、郵件、地圖或客服能力的服務提供商。

任何代表我們處理使用者資料的第三方，都必須依照本隱私政策與適用法律的要求，提供相同或同等水準的資料保護。`,
      section6Title: '6. 保存期限、刪除與安全措施',
      section6Content: `只要您的帳號處於活躍狀態且相關資料仍為提供服務所必需，我們就會保留帳號記錄、訂閱歷史與生成內容。

臨時上傳檔案與處理中間產物會在不再需要用於本次任務、客服支援、安全審查或法律合規時被刪除或解除關聯。您可以從歷史記錄中刪除生成內容，也可以透過 App 內的帳號刪除流程或聯絡我們，申請刪除帳號及符合條件的個人資料。

如為稅務、會計、爭議處理、拒付防禦、反詐欺或其他法律義務所必需，我們可能會延長保留部分記錄。我們會採取合理的管理、技術與組織措施，防止個人資訊遭到未經授權的存取、遺失、濫用或洩露。`,
      section7Title: '7. 您的權利與選擇',
      section7Content: `根據您所在地及適用法律，您可能享有存取、查閱、更正、刪除、取得副本、反對或限制處理個人資訊的權利。

對於可選處理活動，您也可以撤回同意，並透過裝置設定停止向我們提供相機、相簿、通知或定位權限。如您不希望再接收非必要通知，也可以在提供該選項的情況下取消訂閱。`,
      section8Title: '8. 未成年人、跨境傳輸、政策更新與聯絡方式',
      section8Content: `CatooAI 不面向未達到當地法律允許其獨立同意資料處理年齡的兒童。未經適當授權，我們不會故意收集兒童個人資訊。

由於我們的服務可能依賴全球化基礎設施提供商，您的資訊可能會在您所在國家或地區之外被處理。在此情況下，我們會採取適用法律要求的相應保護措施。

我們可能會不時更新本隱私政策。如遇重大變更，我們會在適用情況下透過 App、網站、電子郵件或其他合理方式提前通知您。

如您希望諮詢隱私問題、撤回同意或申請刪除資料，請聯絡 support@catoo.ai。`
    },
    copyright: '© 2025 Catoo. 保留所有權利。'
  };
